import { useTranslation } from '@pypestream/translations';
import { useMemo } from 'react';

import { toSolutionGroupsTranslate } from './shared';

/**
 * `translate` for `buildSolutionGroupViews`. `t` changes identity with the
 * active language, so a memo keyed on the result re-renders on a language switch.
 */
export const useSolutionGroupsTranslate = () => {
  const [t] = useTranslation();
  return useMemo(() => toSolutionGroupsTranslate(t), [t]);
};
